var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"collarCanvas",attrs:{"id":_vm.canvasId}},[_c('div',{staticClass:"collar-title"},[_vm._v(_vm._s(_vm.collar))])])}
var staticRenderFns = []

export { render, staticRenderFns }